import { createProviderStateHook } from '@veriok/utils';

import { ApiProvider, ApiProviderContext } from './provider.tsx';

const useApiProvider = createProviderStateHook(ApiProvider, ApiProviderContext);

export { useApiProvider };
